export default __webpack_public_path__ + "static/media/ONE - 2.aafe0778.jpg";